import { render, staticRenderFns } from "./orgRoleChoose.vue?vue&type=template&id=9ac18e94&"
import script from "./orgRoleChoose.vue?vue&type=script&lang=js&"
export * from "./orgRoleChoose.vue?vue&type=script&lang=js&"
import style0 from "./orgRoleChoose.vue?vue&type=style&index=0&id=9ac18e94&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports